import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { PROFILE_FRAGMENT } from "./profile.fragment";

export interface Data {
  message: string;
}

export interface Variables {
  profile: {
    email?: string;
    firstName?: string;
    lastName?: string;
    lang?: string;
    timeZone?: string;
    password?: string;
  };
}

export const MUTATION = gql`
  mutation updateProfile($profile: ProfileInput!) {
    updateProfile(profile: $profile) {
      ...Profile
    }
  }

  ${PROFILE_FRAGMENT}
`;

export const useUpdateProfileMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> =>
  useMutation<Data, Variables>(MUTATION, options);
